import type {
  BillingMode,
  ClinicalSetting,
  ProcedureCode,
} from "$global-providers/rxdb-provider/collections/epocus-billing";
import type { EpocusProgram } from "$global-providers/rxdb-provider/collections/epocus-program";
import { CPT_PC_TC_INDICATORS } from "./cpt-pc-tc-indicators";

type ProgramBillingSetting = Pick<
  EpocusProgram,
  "clinicalSetting" | "billingModifierOverride"
>;

const PROFESSIONAL_COMPONENT = "-26";

const PC_TC_INDICATORS_WITH_PROFESSIONAL_COMPONENT = new Set(["1"]);

export const splitsProfessionalComponent = (cpt: string): boolean =>
  PC_TC_INDICATORS_WITH_PROFESSIONAL_COMPONENT.has(
    CPT_PC_TC_INDICATORS[cpt] ?? "",
  );

export const billingModifierFor = (
  { clinicalSetting, billingModifierOverride }: ProgramBillingSetting,
  cpt: string,
): string | null => {
  if (billingModifierOverride === "mod_26") return PROFESSIONAL_COMPONENT;
  if (billingModifierOverride === "none") return null;
  return clinicalSetting !== "office" && splitsProfessionalComponent(cpt)
    ? PROFESSIONAL_COMPONENT
    : null;
};

export const billingRecordSettingFor = (
  program: ProgramBillingSetting,
  procedureCodes: readonly Pick<ProcedureCode, "modifier">[],
): { clinicalSetting: ClinicalSetting; billingMode: BillingMode } => ({
  clinicalSetting: program.clinicalSetting.toUpperCase() as ClinicalSetting,
  billingMode: procedureCodes.some(({ modifier }) => modifier !== null)
    ? "COMPONENT"
    : "GLOBAL",
});
